<template>
    <div class="video-manigement-page">
        <div class="df both-side">
            <a-select v-model:value="requestPayload.productType" @change="getData" :options="machineOptions"
                placeholder="产品类型" allowClear>
            </a-select>

            <a-button size="small" type="primary" @click="handleUpdateRecord(1, null)">新增</a-button>
        </div>

        <div class="after-sale-video-detail">

            <div v-for="product in table.data" :key="product.id" class="wrapper-card">

                <div class="wrapper after-sale-back">

                    <div class="wrapper-text ">
                        <span>{{ product.title }}</span>
                    </div>

                    <div class="wrapper-subtext ">
                        <span>{{ product.notes }}</span>
                    </div>
                    <!-- 
                    <div class="tooltip-toolbar">
                 
                    </div> -->
                    <a-dropdown class="tooltip-toolbar">
                        <template #overlay>
                            <a-menu @click="handleAction($event, 1, product)">
                                <a-menu-item key="insert">新增</a-menu-item>
                                <a-menu-item key="edit">修改</a-menu-item>
                                <a-menu-item key="delete">删除</a-menu-item>
                            </a-menu>
                        </template>
                        <a-button size="small">
                            操作
                            <DownOutlined />
                        </a-button>
                    </a-dropdown>
                    <!-- <img :src="product.filePath"> -->
                </div>

                <div class="wrapper wrapper-list">
                    <div v-for="(videoInfo) in product.children" :key="videoInfo.name" class="card">
                        <div class="tiitle">
                            {{ videoInfo.title }}
                            <a-dropdown>
                                <template #overlay>
                                    <a-menu @click="handleAction($event, videoInfo.level, videoInfo)">
                                        <a-menu-item key="insert">新增</a-menu-item>
                                        <a-menu-item key="edit">修改</a-menu-item>
                                        <a-menu-item key="delete">删除</a-menu-item>
                                    </a-menu>
                                </template>
                                <a-button size="small">
                                    操作
                                    <DownOutlined />
                                </a-button>
                            </a-dropdown>
                        </div>
                        <div v-for="(video, index) in videoInfo.children" :key="video.id" class="info df">

                            <div v-if="video.filePath" @click="handlePreviewVideo(video.filePath)">
                                <img :src="productOption[product.title]?.list[index % 2]" alt="">

                                <img src="@/assets/img/page/after-sale-wan-start.png" class="start-img" alt="">
                            </div>

                            <div class="sub-title">
                                {{ video.title }}

                                <a-dropdown>
                                    <template #overlay>
                                        <a-menu @click="handleAction($event, video.level, video)">
                                            <a-menu-item key="edit">修改</a-menu-item>
                                            <a-menu-item key="delete">删除</a-menu-item>
                                        </a-menu>
                                    </template>
                                    <a-button size="small">
                                        操作
                                        <DownOutlined />
                                    </a-button>
                                </a-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>


        <!-- <template v-if="table.data.length > 0">
            <a-table :defaultExpandAllRows="true" :data-source="table.data" bordered :pagination="false"
                :columns="columns" rowKey="id" :scroll="{ x: 'calc( 100vw - 380px )', y: 'calc( 100vh - 310px )' }"
                style="margin-top: 20px;">
                <template #action="{ record }">
                    <a-space>
                        <a-button size="small" @click="handleUpdateRecord(record.level + 1, { pid: record.id, productType: record.productType })"
                            v-if="record.level !== 3">
                            新增 {{ getLevelOptions(record.level + 1).title }} </a-button>
                        <a-button size="small" type="primary"
                            @click="handleUpdateRecord(record.level, record)">修改</a-button>


                        <a-button size="small" danger @click="handleDeleteRecord(record)"> 删除</a-button>
                    </a-space>


                </template>
</a-table>
</template> -->

        <management-form ref="managementFormRef" @handleUpdateTable="getData"></management-form>

        <a-modal v-model:visible="previewVisible" title="视频预览" width="700px" :destroyOnClose="true">
            <video :src="previewFilePath" controls width="600"></video>
        </a-modal>

    </div>
</template>

<script>
import { defineComponent, reactive, ref, watch } from "vue";
import { useTable } from "@/views/notice/serve/table";
import { getProductVideoList, deleteProductVideo } from '@/request/view/afterSale.js';
import { Toast } from "@/utils";
import { DownOutlined } from '@ant-design/icons-vue'
import managementForm from '@/views/afterSale/videoManagement/form.vue';
import { machineOptions } from './data';

export default defineComponent({
    components: {
        managementForm, DownOutlined
    },
    setup(props, context) {
        const managementFormRef = ref();

        const {
            requestConfig,
            table,
            requestPayload,
            initPayload,
            getListData,
            searchData,
            deleteRecords,
            hanldeUpdatePageNum,
        } = useTable();

        requestConfig.pull_fn = getProductVideoList;
        requestConfig.delete_fn = deleteProductVideo;

        initPayload({
            productType: null
        })

        const columns = [
            { title: "序号", dataIndex: "id", align: "center", width: '80px' },
            { title: "类型", dataIndex: "productType", align: "center", width: '120px' },
            { title: "标题", dataIndex: "title", align: "center", width: '260px' },
            { title: "备注", dataIndex: "notes", align: "center", width: '260px' },
            { title: "操作", slots: { customRender: 'action' }, align: "center", width: '160px', fixed: 'right' },
        ]

        const productOption = {
            '光学生物测量仪(天鹅)': {
                imgclass: 'swan',
                seriesName: 'Swan系列',
                list: [require(`../../../assets/img/page/after-sale-swan-0.png`), require(`../../../assets/img/page/after-sale-swan-1.png`)],
                poster: require('../../../assets/img/page/after_sale_swan.png'),
            },
            '视力筛查仪(天鸽)': {
                imgclass: 'columba',
                seriesName: 'Columba系列',
                list: [require(`../../../assets/img/page/after-sale-columba-0.png`), require(`../../../assets/img/page/after-sale-columba-1.png`)],
                poster: require('../../../assets/img/page/after_sale_columba.png'),
            },
            "Optic Biometer  Swan": {
                imgclass: "swan",
                seriesName: "Swan系列",
                list: [
                    require(`../../../assets/img/page/after-sale-swan-0.png`),
                    require(`../../../assets/img/page/after-sale-swan-1.png`),
                ],
                poster: require("../../../assets/img/page/after_sale_swan.png"),
            },
            "Vision Screener Columba": {
                imgclass: "columba",
                seriesName: "Columba系列",
                list: [
                    require(`../../../assets/img/page/after-sale-columba-0.png`),
                    require(`../../../assets/img/page/after-sale-columba-1.png`),
                ],
                poster: require("../../../assets/img/page/after_sale_columba.png"),
            },
            '视功能检查训练仪(星豚)': {
                imgclass: 'starton',
                seriesName: 'Starton系列',
                list: [require(`../../../assets/img/page/after_sale_starton-0.png`), require(`../../../assets/img/page/after_sale_starton-1.png`)],
                poster: require('../../../assets/img/page/after_sale_starton.png'),
            },
            '功能镜片检测仪(天猫)': {
                imgclass: 'lynx',
                seriesName: 'Lynx系列',
                list: [require(`../../../assets/img/page/after-sale-lynx-0.png`), require(`../../../assets/img/page/after-sale-lynx-1.png`)],
                poster: require('../../../assets/img/page/after_sale_lynx.png'),
            },
        };

        const getLevelOptions = (level) => {
            const options = {
                accept: null,
                title: ''
            }

            switch (level) {
                case 1:
                    options.accept = '.png,.jpg';
                    options.title = '设备分类'
                    break;
                case 2:
                    options.title = '分类标题'
                    break;
                case 3:
                    options.title = '操作视频'
                    options.accept = '.mp4';
                    break;
                default:
                    break;
            }

            return options;
        }

        const setIteLevel = (item, defaultLevel) => {
            item.level = defaultLevel;
            // 值类型变成引用类型
            const nextLevel = defaultLevel += 1;
            if (item.children && item.children.length > 0) {
                item.children.forEach((subItem) => {
                    setIteLevel(subItem, nextLevel)
                })
            }
        }

        const getData = () => {
            getListData({ unPagingRequest: true }).then(() => {
                table.data.forEach((item) => {
                    setIteLevel(item, 1)
                });
            })
        }

        const handleUpdateRecord = (level, data) => {
            const options = getLevelOptions(level);
            managementFormRef.value.showModal(options, data)
        }

        const handleDeleteRecord = (record) => {
            const deleteIdList = [];

            const iteId = (e) => {
                deleteIdList.push(e.id);
                if (e.children && e.children.length > 0) {
                    e.children.forEach((f) => {
                        iteId(f);
                    });
                }
            }
            iteId(record)

            deleteRecords(deleteIdList, { title: "确认删除该条记录？" }).then(() => {
                getData();
            })
        }

        const handleAction = (e, index, record) => {
            const { key } = e;

            switch (key) {
                case 'insert':
                    handleUpdateRecord(index + 1, { pid: record.id, productType: record.productType })
                    break;
                case 'edit':
                    handleUpdateRecord(index, record)
                    break;
                case 'delete':
                    handleDeleteRecord(record)
                    break;
                default:
                    break;
            }
        }

        const previewVisible = ref(false);
        const previewFilePath = ref('');


        const handlePreviewVideo = (path) => {
            console.log(path, '++++++++++++++')
            previewVisible.value = true;
            previewFilePath.value = path;
        }


        getData();

        return {
            table,
            previewVisible,
            previewFilePath,
            getData,
            handleAction,
            handleUpdateRecord,
            handleDeleteRecord,
            getLevelOptions,
            handlePreviewVideo,
            productOption,
            machineOptions,
            columns,
            requestPayload,
            managementFormRef,
        };
    },
});
</script>

<style scoped lang="less">
.video-manigement-page {
    border-radius: 20px;
    box-shadow: 0 0 10px 0 #ccc;
    padding: 20px;
    height: calc(100vh - 120px);
    margin: 0px auto;
    background: #fff;
}

.after-sale-video-detail {
    // background: #F7F8FB;
    display: flex;
    margin-top: 20px;

    .tooltip-toolbar {
        position: absolute;
        right: 10px;
        top: 10px;
    }

    .wrapper-card {
        box-shadow: 0 0 10px 0 #ccc;
        margin-right: 10px;
        height: calc(100vh - 210px);
        overflow-y: scroll;
    }

    .wrapper {
        padding: 0 0.08683rem;
    }

    .after-sale-back {
        width: 375px;
        background: url('../../../assets/img/page/after_sale_machine.png');
        background-size: 100% 100%;
        position: relative;
        padding-top: 10px;
        height: 100px;

        h1 {
            font-size: 0.12885rem;
            color: #FFFFFF;
            line-height: 0.15686rem;
            text-align: center;
        }

        img {
            width: 0.63866rem;
            height: 0.52381rem;
            position: absolute;
            right: 0.14286rem;
            top: 0.02801rem;
        }

        .columba {
            width: 1.11765rem;
            height: 0.75910rem;
            right: 0.11204rem;
            bottom: 0.74230rem;
        }

        .wrapper-text {
            font-size: 0.08403rem;
            color: #FFFFFF;
            margin-bottom: 0.03641rem;
        }

        .wrapper-subtext {
            font-size: 0.08683rem;
            color: #FFFFFF;

            span {
                margin-right: 0.05602rem;
            }
        }
    }

    .wrapper-list {

        .card {
            background: #FFFFFF;
            box-shadow: 0.00000rem 0.1rem 0.1rem 0rem #F0F4F9;
            border-radius: 0.04202rem;
            margin-bottom: 0.08683rem;
            padding: 0.08683rem;

            .tiitle {
                width: 300px;
                font-size: 18px;
                letter-spacing: 2px;
                font-weight: bold;
                border-bottom: 2px solid #F2F2F2;
                padding-bottom: 0.08683rem;
                margin-bottom: 10px;
            }

            .info {
                margin-bottom: 0.08683rem;
                position: relative;

                img {
                    width: 0.56022rem;
                    height: 0.44818rem;
                    margin-right: 10px;
                }

                .start-img {
                    width: 0.17927rem;
                    height: 0.17927rem;
                    position: absolute;
                    left: 0.22689rem;
                    top: 0.16807rem;
                }

                .sub-title {
                    padding-top: 0.05882rem;
                    font-weight: 400;
                    font-size: 0.08683rem;
                    width: 190px;
                    color: #333333;
                }
            }

        }
    }
}
</style>
